import { render, staticRenderFns } from "./PrintBoxQrCode.vue?vue&type=template&id=66283d04&scoped=true&"
import script from "./PrintBoxQrCode.vue?vue&type=script&lang=js&"
export * from "./PrintBoxQrCode.vue?vue&type=script&lang=js&"
import style0 from "./PrintBoxQrCode.vue?vue&type=style&index=0&id=66283d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66283d04",
  null
  
)

export default component.exports